export default __webpack_public_path__ + "static/media/cp_geo_unknown.9185468b.svg";